// hooks
import React, { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// components
import { Col, Row } from 'react-bootstrap';
import OrangeLine from '../../components/OrangeLine';
import Button from '../../components/Button';
import GlobalContext from '../../components/GlobalContext';
import { useLocation } from 'react-router';
import './PricesNewGeorgian.css';
import usaFlag from './../../assets/images/flags/DELAWARE.svg';
import chinaFlag from './../../assets/images/flags/CHINA.svg';
import turkeyFlag from './../../assets/images/flags/TURKEY.svg';
import greeceFlag from './../../assets/images/flags/GREECE.svg';

export default function PricesNewGeorgian({ route, navigation }) {
  const { t } = useTranslation();
  const { setShowCalculator } = useContext(GlobalContext);
  const { hash } = useLocation();
  const ref = useRef();

  const showCalculatorHandler = () => {
    setShowCalculator(true);
  };

  useEffect(() => {
    if (hash === '#prices') {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start', alignToTop: true });
    }
  }, []);

  const [activeTab, setActiveTab] = React.useState('all');

  return (
    <div>
      <link href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css' rel='stylesheet'></link>
      <Row className='prices-row' id='prices'>
        <Col lg={12} md={12} xs={12} style={{ padding: '0 25px' }}>
          <div className='prices-right-div'>
            <OrangeLine />
            <h2 className='about-us-title mt-2'>ტრანსპორტირების ფასები</h2>
            <br />
            <div className='tabs'>
              <div className={`bold tab ${activeTab === 'all' && 'active'}`} style={{ fontFamily: 'HelveticaBoldCaps' }} onClick={() => setActiveTab('all')}>
                ყველა
              </div>
              <div className={`tab ${activeTab === 'usa' && 'active'}`} style={{ fontFamily: 'HelveticaBoldCaps' }} onClick={() => setActiveTab('usa')}>
                აშშ
              </div>
              <div className={`tab ${activeTab === 'china' && 'active'}`} style={{ fontFamily: 'HelveticaBoldCaps' }} onClick={() => setActiveTab('china')}>
                ჩინეთი
              </div>
              <div className={`tab ${activeTab === 'turkey' && 'active'}`} style={{ fontFamily: 'HelveticaBoldCaps' }} onClick={() => setActiveTab('turkey')}>
                თურქეთი
              </div>
              <div className={`tab ${activeTab === 'greece' && 'active'}`} style={{ fontFamily: 'HelveticaBoldCaps' }} onClick={() => setActiveTab('greece')}>
                საბერძნეთი
              </div>
            </div>
          </div>
          <div className='pricing-container'>
            {(activeTab === 'all' || activeTab === 'usa') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={usaFlag} />
                  </div>
                  <div className='country-name' style={{ fontFamily: 'HelveticaBoldCaps' }}>
                    აშშ
                  </div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-plane-departure'></i> სტანდარტული გადაზიდვა
                      </h3>
                      <p className='method-description'>რეგულარული საჰაერო გადაზიდვა აშშ-დან საქართველოში</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>სტანდარტული ტარიფი</div>
                          <div className='price-value'>$9/კგ</div>
                          <div className='price-details'>ყველა ამანათისთვის</div>
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>ტრანსპორტირების ღირებულება გამოითვლება მოცულობით და სასწორის წონებს შორის მაქსიმალურით</li>
                          <li>მიწოდების დრო: 7-10 სამუშაო დღე</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(activeTab === 'all' || activeTab === 'china') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={chinaFlag} />
                  </div>
                  <div className='country-name' style={{ fontFamily: 'HelveticaBoldCaps' }}>
                    ჩინეთი
                  </div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-plane-departure'></i> საჰაერო გადაზიდვა
                      </h3>
                      <p className='method-description'>სწრაფი საჰაერო გადაზიდვა ჩინეთიდან საქართველოში</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>სტანდარტული ტარიფი</div>
                          <div className='price-value'>$12/კგ</div>
                          <div className='price-details'>ყველა ამანათისთვის</div>
                        </div>

                        {/* <div className='price-card promo'>
                          <div className='price-type'>სააქციო ტარიფი</div>
                          <div className='price-value'>$9/კგ</div>
                          <div className='price-details'>შეზღუდული დროით</div>
                          <div className='price-badge'>1 ივნისი - 1 სექტემბერი, 2025</div>
                        </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>ტრანსპორტირების ღირებულება გამოითვლება მოცულობით და სასწორის წონებს შორის მაქსიმალურით</li>
                          <li>მიწოდების დრო: 5-8 სამუშაო დღე</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-moving'></i> სახმელეთო გადაზიდვა
                      </h3>
                      <p className='method-description'>ეკონომიური სახმელეთო ტრანსპორტირება</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>სტანდარტული ტარიფი</div>
                          <div className='price-value'>$5.5/კგ</div>
                          <div className='price-details'>ყველა ამანათისთვის</div>
                        </div>

                        <div className='price-card promo'>
                          <div className='price-type'>სააქციო ტარიფი</div>
                          <div className='price-value'>$2/კგ</div>
                          {/* <div className='price-details'>
                            30კგ-მდე: $3.5/კგ
                            <br />
                            30კგ-ზე მეტი: $2.5/კგ
                          </div> */}
                          <div className='price-badge'>10 ნოემბერი, 2025 - 1 იანვარი, 2026</div>
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>30კგ-მდე მოცულობითი წონის ამანათები - სასწორის წონით</li>
                          <li>30კგ და მეტი მოცულობითი ან რეალური წონის ამანათები - მოცულობით და სასწორის წონებს შორის მაქსიმალურით</li>
                          <li>მიწოდების დრო: 30-45 სამუშაო დღე</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-loading'></i> დიდი ტვირთების სახმელეთო ტრანსპორტირება
                      </h3>
                      <p className='method-description'>დიდი შეკვეთების გადაზიდვა</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>ტარიფი</div>
                          <div className='price-value'>ფასი შეთანხმებით</div>
                          <div className='price-details'>მინიმალური მოცულობა: 1მ³</div>
                          <div className='price-details'>მაქსიმალური წონა: 250 კგ მ³-ზე</div>
                          {/* <div className='price-badge'>1 ივნისი - 1 სექტემბერი, 2025</div> */}
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>მოცულობაზე დაფუძნებული ფასწარმოქმნა</li>
                          <li>მინიმალური შეკვეთა: 1მ³</li>
                          <li>მიწოდების დრო: 30-45 სამუშაო დღე</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(activeTab === 'all' || activeTab === 'turkey') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={turkeyFlag} />
                  </div>
                  <div className='country-name' style={{ fontFamily: 'HelveticaBoldCaps' }}>
                    თურქეთი
                  </div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-moving'></i> სტანდარტული გადაზიდვა
                      </h3>
                      <p className='method-description'>რეგულარული სახმელეთო გადაზიდვა თურქეთიდან</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>სტანდარტული ტარიფი</div>
                          <div className='price-value'>$4/კგ</div>
                          <div className='price-details'>ყველა ამანათისთვის</div>
                        </div>

                        {/* <div className='price-card promo'>
                          <div className='price-type'>სააქციო ტარიფი</div>
                          <div className='price-value'>$1-3/კგ</div>
                          <div className='price-details'>
                            50კგ-მდე: $3/კგ
                            <br />
                            50კგ-ზე მეტი: $1/კგ
                          </div>
                          <div className='price-badge'>1 ივნისი - 1 სექტემბერი, 2025</div>
                        </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>50კგ-მდე მოცულობითი წონის ამანათები - სასწორის წონით</li>
                          <li>50კგ და მეტი მოცულობითი წონის ამანათები - მოცულობით და სასწორის წონებს შორის მაქსიმალურით</li>
                          <li>მიწოდების დრო: 7-10 სამუშაო დღე</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(activeTab === 'all' || activeTab === 'greece') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={greeceFlag} />
                  </div>
                  <div className='country-name' style={{ fontFamily: 'HelveticaBoldCaps' }}>
                    საბერძნეთი
                  </div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-moving'></i> სტანდარტული გადაზიდვა
                      </h3>
                      <p className='method-description'>რეგულარული სახმელეთო გადაზიდვა საბერძნეთიდან</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>სტანდარტული ტარიფი</div>
                          <div className='price-value'>3.5€/კგ</div>
                          <div className='price-details'>ყველა ამანათისთვის</div>
                        </div>

                        {/* <div className='price-card promo'> */}
                        {/* <div className='price-type'>სააქციო ტარიფი</div> */}
                        {/* <div className='price-value'>1€/კგ</div> */}
                        {/* <div className='price-details'>
                            50კგ-მდე: 3.5€/კგ
                            <br />
                            50კგ-დან 200კგ-მდე: 2€/კგ
                          </div> */}
                        {/* <div className='price-badge'>4 ივნისი - 1 აგვისტო, 2025</div> */}
                        {/* </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>50კგ-მდე მოცულობითი წონის ამანათები - სასწორის წონით</li>
                          <li>50კგ და მეტი მოცულობითი ან რეალური წონის ამანათები - მოცულობით და სასწორის წონებს შორის მაქსიმალურით</li>
                          <li>მიწოდების დრო: 7-14 დღე</li>
                          <li>რეისების სიხშირე: კვირაში - 1</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-loading'></i> დიდი ტვირთების სახმელეთო ტრანსპორტირება
                      </h3>
                      <p className='method-description'>ნაკრები ტვირთები LTL</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>ტარიფი</div>
                          <div className='price-value'>ფასი შეთანხმებით</div>
                          <div className='price-details'>მინიმალური მოცულობა: 1მ³</div>
                          <div className='price-details'>მაქსიმალური წონა: 250 კგ მ³-ზე</div>
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>მოცულობაზე დაფუძნებული ფასწარმოქმნა</li>
                          <li>მინიმალური შეკვეთა: 1მ³</li>
                          <li>მიწოდების დრო: 10-14 დღე</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className='additional-info-new'>
            <div className='info-card'>
              <div className='info-header'>
                <i className='fas fa-plus-circle'></i> დამატებითი მომსახურება
              </div>
              <div className='info-content'>
                <div className='service-item'>
                  <span className='service-name'>24-საათიანი გარე ლოქერის მომსახურება</span>
                  <span className='service-fee'>3&nbsp;ლარი</span>
                </div>
              </div>
            </div>

            <div className='info-card'>
              <div className='info-header'>
                <i className='fas fa-shield-alt'></i> უსაფრთხოების მომსახურების გადასახადი
              </div>
              <div className='info-content'>
                <p>თითოეული ამანათის ტრანსპორტირების ღირებულებას დაემატება უსაფრთხოების მომსახურების გადასახადი</p>
                <table className='fee-table'>
                  <thead>
                    <tr>
                      <th>დეკლარირებული თანხა</th>
                      <th>გადასახდელი თანხა</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>100 ლარამდე</td>
                      <td>1 ლარი</td>
                    </tr>
                    <tr>
                      <td>100-დან 200 ლარამდე</td>
                      <td>2 ლარი</td>
                    </tr>
                    <tr>
                      <td>200-დან 300 ლარამდე</td>
                      <td>3 ლარი</td>
                    </tr>
                    <tr>
                      <td>300-დან 3000 ლარამდე</td>
                      <td>დეკლარირებული თანხის 2%</td>
                    </tr>
                    <tr>
                      <td>3000-დან 10,000 ლარამდე</td>
                      <td>დეკლარირებული თანხის 4%</td>
                    </tr>
                    <tr>
                      <td>10,000-დან 20,000 ლარამდე</td>
                      <td>დეკლარირებული თანხის 8%</td>
                    </tr>
                    <tr>
                      <td>20,000 ლარი ან მეტი</td>
                      <td>დეკლარირებული თანხის 12%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className='calculator-cta'>
            <p>გჭირდებათ ზუსტი ტრანსპორტირების ღირებულების გაანგარიშება?</p>
            <div onClick={showCalculatorHandler} className='btn-pricing'>
              ფასის გამოთვლა
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
